import { formatInTimeZone } from 'date-fns-tz';

export default {
    name: 'app-countdown',
    props: {
        fromTime: {
            default: null,
            type: String,
        },
        timeout: {
            default: 0,
            type: Number,
        },
        model: {
            type: Number,
            default: 0,
        },
    },
    model: {
        prop: 'model',
        event: 'change',
    },
    data() {
        return {
            systemTimezone: 'Europe/London',
            timerOutput: null,
            countDownClass: '',
            intervalId: null,
            countDownToTime: new Date(this.fromTime).getTime(),
        };
    },
    mounted() {
        console.log('Component %s mounted.', this.$options.name);

        this.startTimer();

        this.$nextTick(() => {
            this.intervalId = setInterval(() => {
                this.startTimer();
            }, 1000);
        });
    },

    methods: {
        currentTime() {
            return new Date(formatInTimeZone(new Date(), this.systemTimezone, 'yyyy-MM-dd HH:mm:ss')).getTime();
        },
        startTimer: function () {
            const timeNow = this.currentTime(); //need to convert current time to system timezone(Europe/London) due to countDownToTime we get in system timezone
            const timeDifference = this.countDownToTime + this.timeout * 1000 - timeNow;

            //need to change item.diffSec
            this.$emit('change', parseInt(timeDifference / 1000));

            if (timeDifference < 1000) {
                this.timerOutput = null;
                clearInterval(this.intervalId);
            } else {
                // const timeDifference = this.diffSec * 1000;
                const millisecondsInOneSecond = 1000;
                const millisecondsInOneMinute = millisecondsInOneSecond * 60;
                const millisecondsInOneHour = millisecondsInOneMinute * 60;
                const millisecondsInOneDay = millisecondsInOneHour * 24;
                const differenceInDays = timeDifference / millisecondsInOneDay;
                const remainderDifferenceInHours = (timeDifference % millisecondsInOneDay) / millisecondsInOneHour;
                const remainderDifferenceInMinutes = (timeDifference % millisecondsInOneHour) / millisecondsInOneMinute;
                const remainderDifferenceInSeconds = (timeDifference % millisecondsInOneMinute) / millisecondsInOneSecond;
                const remainingDays = Math.floor(differenceInDays);
                const remainingHours = Math.floor(remainderDifferenceInHours);
                const remainingMinutes = Math.floor(remainderDifferenceInMinutes);
                let remainingSeconds = Math.floor(remainderDifferenceInSeconds);

                if (!remainingSeconds && (remainingMinutes || remainingHours || remainingDays)) {
                    remainingSeconds = '00';
                }

                this.countDownClass = remainingDays || remainingHours ? 'big' : remainingMinutes ? 'medium' : 'small';

                this.timerOutput =
                    (remainingDays ? remainingDays + 'd ' : '') +
                    (remainingHours ? (remainingDays ? this.addLeadZero(remainingHours) : remainingHours) + 'h ' : '') +
                    (remainingMinutes ? this.addLeadZero(remainingMinutes) + 'm ' : '') +
                    (remainingSeconds && !remainingDays ? this.addLeadZero(remainingSeconds) + 's' : '');
                this.countDownToTime = this.countDownToTime + 1;
            }
        },

        addLeadZero(number) {
            return String(number).padStart(2, '0');
        },
    },
    computed: {},
};
